import { DateTime } from 'luxon';
import { LicenseTypeEnum } from '../licences/LicenseType';

export type LicenseTerm = {
    id: string;
    licenseType: LicenseTypeEnum;
    notes: string;
    startDate: DateTime;
    endDate: DateTime;
    file?: File;
    downloadUrl: string;
};

export type LicenseTermApi = {
    id: string;
    licenseType: LicenseTypeEnum;
    notes: string;
    startDate: Date;
    endDate: Date;
    file?: File;
    downloadUrl: string;
};

export const defaultLicenseTerm: LicenseTerm = {
    id: '',
    licenseType: LicenseTypeEnum.Commercial,
    notes: '',
    downloadUrl: '',
    startDate: DateTime.fromISO(''),
    endDate: DateTime.fromISO(''),
};
